import React from "react";
import { withRouter } from "react-router-dom";
import { BreadcrumbContainer, Breadcrumbs, BreadCrumArrow } from "./style";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { initiateTracking, recordError } from "../../utils/commonUtil";

BreadcrumbComponent.defaultProps = {
  breadcrumbRoutes: [
    {
      routeName: "Home",
      path: ""
    }
  ]
};

function BreadcrumbComponent(props) {
  function itemRender(route, params, routes, paths) {    
    const last = routes.indexOf(route) === routes.length - 1;
    const routeLink = paths[paths.length-1];
    return route.routeName === 'Home' ? <Link to='/'>{route.routeName}</Link> :last ? (
      <span>{typeof route.routeName === 'function' ? route.routeName(): route.routeName}</span>
    ) : (
      <Link 
        onClick={() => { try { initiateTracking('breadCrumb', 'Breadcrumb Navigation DP', routes[routes.length - 1].routeName, route.routeName)} catch(error) { recordError(error)}}} 
        to={"/" + (routeLink ? routeLink : "")}>
        {route.routeName}
      </Link>
    );
  }
  return (
    <BreadcrumbContainer className={props.className}>
      <Breadcrumbs
        data-test='breadCrumbBlock'
        separator={<BreadCrumArrow>/</BreadCrumArrow>}
        itemRender={itemRender}
        routes={props.breadcrumbRoutes}
      />
    </BreadcrumbContainer>
  );
}

BreadcrumbComponent.propTypes = {
  breadcrumbRoutes: PropTypes.array
};

export default withRouter(BreadcrumbComponent);
